<template>
  <div class="CheckoutPage">
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        class="fullscreen"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>

    <template v-else>
      <div :class="{ 'container-wider': isCheckoutStepRoute }" class="CheckoutPage_content mobile_content">
        <div class="container-checkout">
          <checkout-sign-up
            v-if="!isAuthenticated"
            :bundles="bundlesName"
          />

          <checkout-personal-details
            v-if="isAuthenticated"
            :personal-detail="personalDetail"
            :has-subscription="personalDetail.hasSubscription"
            @personal-detail-change="setPersonalDetailItem($event)"
            :bundles="bundlesName"
          />

          <checkout-address
            :is-authenticated="isAuthenticated"
            :has-address="hasAddress"
            :countries="countries"
            :shipping="shipping"
            :billing="billing"
            :has-billing="hasBilling"
            :has-subscription="personalDetail.hasSubscription"
            :bundles="bundles"
            :preview-bundle="previewBundle"
            :bundles-with-quantity="bundlesWithQuantity"
            @shipping-change="setShippingAddressItem($event)"
            @billing-change="setBillingAddressItem($event)"
          />

          <section class="CheckoutPaymentMethod" :class="{'step-show': hasAddress}">
            <h2 class="title title-step" v-if="!hasAddress">
              {{ $t('checkout.payment.title', 'Payment method') }}
            </h2>

            <checkout-payment-method
              v-else
              :bundles="bundles"
              :preview-bundle="previewBundle"
              :bundle-name="bundlesName"
            />
          </section>
          <product-usp
            v-if=" !isFamilyPack && currentCountryCode === 'CA'"
            class ="SingleBundleUsp"
            :usp="cartDetails.groups[0].items[0].usp"
          />

            <div class="cancel" v-if="detectedCulture.countryCode === 'DE'">
          <div class="demo">
            <p >{{ $t('checkout.personalDetails.common.createAccount.login.tips1', 'Subscriptions') }}</p>
           <h2>{{ $t('checkout.personalDetails.common.createAccount.login.subTips1', 'Easy cancellation of your contracts') }}</h2>
          </div>
             <div class="demo1">
            <app-button
              @click.prevent="openModalStep2"
            >
              {{ $t('checkout.personalDetails.common.createAccount.button.login1', 'Cancel contracts here') }}
            </app-button>

            <app-modal name="newFlowForCancelReplenishment1"  :clickToClose="false" width="500px">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="newFlowForCancelReplenishment_popUp">
              <h2>
                {{ $t('checkout.personalDetails.common.mailsub', "We have received your request to terminate the contract.") }}
              </h2>
                <p >{{ $t('checkout.personalDetails.common.createAccount.login.tips7', 'You will receive a confirmation to your mail') }}</p>
          </div> </div></div>
           <app-button
               @click.prevent="test"
                >
                  {{ $t('checkout.personalDetails.cancellation.popUp.closebutton', "close") }}
                </app-button>
               </app-modal>

        <app-modal name="newFlowForCancelReplenishment" :clickToClose="false" width="500px">
        <div class="v--modal-content">
          <h3 class="modal-title">
          </h3>
          <div class="modal-content">
            <div class="newFlowForCancelReplenishment_popUp">
              <h2>
                {{ $t('checkout.personalDetails.common.popUp.sub', "Please fill the Subscription information you want to terminate.") }}
              </h2>
                <p >{{ $t('checkout.personalDetails.common.createAccount.msg', 'you can find required subscription information on your invoice') }}</p>

      <form class="PersoanlDetail_body" >
        <div class="content">
          <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.firstName', 'First name')"
            :placeholder="$t('checkout.personalDetails.placeholder.firstName', 'First name')"
            v-model.trim="name"
            :top-label="topLabel"
          />
           <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.lastName', 'Surname')"
            :placeholder="$t('checkout.personalDetails.placeholder.lastName', 'Surname')"
            v-model.trim="surName"
            :top-label="topLabel"
          />
          <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.email', 'E-mail Address')"
            :placeholder="$t('checkout.personalDetails.placeholder.email', 'E-mail Address')"
            v-model.trim="fromEmail"
            :top-label="topLabel"
          />
           <r-app-text-input
            :label="$t('checkout.personalDetails.placeholder.number', 'Subscription Number')"
            :placeholder="$t('checkout.personalDetails.placeholder.number', 'Subscription Number')"
            v-model.trim="subscriptionNumber"
            :top-label="topLabel"
          />
        </div>
          </form>

              <div class="modal-button-warpper">

                <app-button
                 
               type="submit"
               :disabled="(!name || !surName || !fromEmail || !subscriptionNumber)"
               @click.prevent="openModalStep3"
                >
                  {{ $t('checkout.personalDetails.cancellation.popUp.button.terminate', "Terminate contract") }}
                </app-button>
              </div>
            </div>
          </div>
        </div>
      </app-modal>
        </div></div>
        </div>
        <aside class="CheckoutPage_cart">
          <p class="backToCart text-right" @click="backToCart">
            {{ $t('checkout.button.backToCart', 'Edit shopping cart') }}
          </p>
          <div class="CheckoutPage_cart-right">
            <div class="CheckoutPage_cart-product">
              <div v-for="group in cartDetails.groups" :key="group.name">
                <div class="Product no-gutters" v-for="(bundle, index) in group.items" :key="index">
                  <div class="img-holder col-md-3">
                    <img class="Product_img" :src="bundle.image" :alt="bundle.title">
                  </div>
                  <div class="show-mobile text-right">
                    <div class="Product_text">
                      <p class="Product_name">{{ bundle.title }}</p>
                      <div class="Product_price col-auto col-md-3">
                        <!--bundles oneTime charge -->
                        <div class="Product_price_item text-right" v-if="group.name !== 'Replenishment' && bundle.oneTimeCharge">
                          <p>
                            <span class="discount" v-if="bundle.oneTimeCharge.discounts">
                              {{ bundle.oneTimeCharge.discounted | formatCurrency }}
                            </span>
                            <span class="origin" :class="{ 'has-discount': !!bundle.oneTimeCharge.discounts }" >
                              {{ bundle.oneTimeCharge.original | formatCurrency }}
                            </span>
                          </p>
                        </div>

                        <!-- only replenshipment charge -->
                        <div class="Product_price_item text-right" v-if="(group.name === 'Replenishment') && !Loading">
                          <p>
                            <span class="discount" v-if="((bundle.monthlyCharge && bundle.monthlyCharge.discounts) || bundle.oneTimeCharge && bundle.oneTimeCharge.discounts) || (bundle.quarterlyCharge && bundle.quarterlyCharge.discounts) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.discounts)">
                              {{ ((bundle.monthlyCharge ? bundle.monthlyCharge.discounted : null) || (bundle.oneTimeCharge ? bundle.oneTimeCharge.discounted : null) || (bundle.quarterlyCharge ? bundle.quarterlyCharge.discounted : null) || (bundle.semiAnnualCharge ? bundle.semiAnnualCharge.discounted : null)) | formatCurrency }}
                            </span>
                            <span
                              class="origin" :class="{ 'has-discount': ((bundle.monthlyCharge && bundle.monthlyCharge.discounts) || bundle.oneTimeCharge && bundle.oneTimeCharge.discounts) || (bundle.quarterlyCharge && bundle.quarterlyCharge.discounts) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.discounts) }"
                              v-if="((bundle.monthlyCharge && bundle.monthlyCharge.original) || (bundle.oneTimeCharge && bundle.oneTimeCharge.original) || (bundle.quarterlyCharge && bundle.quarterlyCharge.original) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.original))"
                            >
                              {{ ((bundle.monthlyCharge && bundle.monthlyCharge.original) || (bundle.oneTimeCharge && bundle.oneTimeCharge.original) || (bundle.quarterlyCharge && bundle.quarterlyCharge.original) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.original)) | formatCurrency }}
                            </span>
                          </p>
                          <p v-for="(specificCharge, index) in bundle.specificMonthsCharges" :key="index">
                            <template v-if="specificCharge.charge.original">
                              <span class="origin" :class="{ 'has-discount': specificCharge.charge.discounted !== specificCharge.charge.original }">
                                {{ specificCharge.charge.original | formatCurrency }}
                              </span>
                              <span v-if="specificCharge.charge.discounted !== specificCharge.charge.original" class="discount">
                                {{ specificCharge.charge.discounted | formatCurrency(true) }}
                              </span>
                            </template>
                          </p>
                        </div>
                      </div>

                      <app-spinner :rhombus-size="rhombusSize" :color="color" v-if="Loading"/>
                    </div>
                 
                  </div>
                  <div class="hide-mobile col-md-9">
                    <div class="Product_text">
                      <p class="Product_name">{{ bundle.title }}</p>
                      <div class="Product_price col-auto">
                        <!-- oneTime charge -->
                        <div class="Product_price_item text-right" v-if="group.name !== 'Replenishment' && bundle.oneTimeCharge">
                          <p>
                            <span class="discount" v-if="bundle.oneTimeCharge.discounts">
                              {{ bundle.oneTimeCharge.discounted | formatCurrency }}
                            </span>
                            <span class="origin" :class="{ 'has-discount': !!bundle.oneTimeCharge.discounts }" >
                              {{ bundle.oneTimeCharge.original | formatCurrency }}
                            </span>
                          </p>
                        </div>

                        <!-- only replenshipment charge -->
                        <div class="Product_price_item text-right" v-if="(group.name === 'Replenishment') && !Loading">
                          <p>
                            <span class="discount" v-if="((bundle.monthlyCharge && bundle.monthlyCharge.discounts) || bundle.oneTimeCharge && bundle.oneTimeCharge.discounts) || (bundle.quarterlyCharge && bundle.quarterlyCharge.discounts) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.discounts)">
                              {{ ((bundle.monthlyCharge ? bundle.monthlyCharge.discounted : null) || (bundle.oneTimeCharge ? bundle.oneTimeCharge.discounted : null) || (bundle.quarterlyCharge ? bundle.quarterlyCharge.discounted : null) || (bundle.semiAnnualCharge ? bundle.semiAnnualCharge.discounted : null)) | formatCurrency }}
                            </span>
                            <span
                              class="origin" :class="{ 'has-discount': ((bundle.monthlyCharge && bundle.monthlyCharge.discounts) || bundle.oneTimeCharge && bundle.oneTimeCharge.discounts) || (bundle.quarterlyCharge && bundle.quarterlyCharge.discounts) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.discounts) }"
                              v-if="((bundle.monthlyCharge && bundle.monthlyCharge.original) || (bundle.oneTimeCharge && bundle.oneTimeCharge.original) || (bundle.quarterlyCharge && bundle.quarterlyCharge.original) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.original))"
                            >
                              {{ ((bundle.monthlyCharge && bundle.monthlyCharge.original) || (bundle.oneTimeCharge && bundle.oneTimeCharge.original) || (bundle.quarterlyCharge && bundle.quarterlyCharge.original) || (bundle.semiAnnualCharge && bundle.semiAnnualCharge.original)) | formatCurrency }}
                            </span>
                          </p>
                          <p v-for="(specificCharge, index) in bundle.specificMonthsCharges" :key="index">
                            <template v-if="specificCharge.charge.original">
                              <span class="origin" :class="{ 'has-discount': specificCharge.charge.discounted !== specificCharge.charge.original }">
                                {{ specificCharge.charge.original | formatCurrency }}
                              </span>
                              <span v-if="specificCharge.charge.discounted !== specificCharge.charge.original" class="discount">
                                {{ specificCharge.charge.discounted | formatCurrency(true) }}
                              </span>
                            </template>
                          </p>
                        </div>
                      </div>
                      <app-spinner :rhombus-size="rhombusSize" :color="color" v-if="Loading"/>
                    </div>
                    <div class="OFSmsg left-align" v-show="bundleflag">  
                         {{ $t('checkout.paymentMethod.bundleoutofstockmessage', 'Product is currently out of stock.') }}
                   </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ShoppingCartPayment">
              <checkout-step-cart
                :cart-details-summary="cartDetails.summary"
                :loading="Loading"
                :bundles="bundlesWithQuantity"
              />
            </div>

            <fp-discount-box
              :bundles-with-quantity = bundlesWithQuantity
              :preview-bundle="previewBundle"
            />
          </div>
        </aside>
      </div>
    </template>

    <generic-custom-code
      :generic-script="genericScript"
      :generic-html="genericHtml"
    />
   </div>
</template>

<script>
  import CheckoutPaymentMethod from 'components/CheckoutPaymentMethod'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { extractErrorMessage } from '@/utilities/common'
  import GenericCustomCode from 'components/GenericCustomCode'
  import { uniq, omit, join, flatten } from 'lodash'
  import Vue from 'vue'
  import CheckoutPersonalDetails from 'components/CheckoutPersonalDetails'
  import CheckoutAddress from 'components/CheckoutAddress'
  import FpDiscountBox from 'components/FpDiscountBox'
  import checkoutStepCart from 'components/CheckoutStepCart'
  import CheckoutSignUp from 'components/CheckoutSignUp'
  import ProductUsp from 'components/ProductUsp'
  import {detectedCulture} from 'utilities/common/culture'

  export default {
    name: 'checkout',

    beforeRouteLeave (to, from, next) {
      let commonPageTitle = window.localStorage.getItem('commonPageTitle')
      if (commonPageTitle) {
        document.title = commonPageTitle
      }
      if (to.name !== 'cart') {
        window.localStorage.removeItem('storedCartItems')
      }
      next()
    },

    beforeRouteEnter (to, from, next) {
      if (from.name === null && to.query.modified !== 'true') {
        window.localStorage.removeItem('storedCartItems')
        window.localStorage.removeItem('bundlesWithPromotions')
        window.localStorage.removeItem('bundlesWithQuantity')
      }
      next(vm => {
        vm.updatePageName(to.meta.pageName)
        if (from.name === 'subscription-error') {
          vm.fromSubscriptionError = true
        } else {
          vm.fromSubscriptionError = false
        }
      })
    },

    components: {
      CheckoutPersonalDetails,
      CheckoutAddress,
      CheckoutPaymentMethod,
      GenericCustomCode,
      FpDiscountBox,
      checkoutStepCart,
      CheckoutSignUp,
      ProductUsp
    },

    data () {
      return {
        isLoading: true,
        fromSubscriptionError: false,
        Loading: false,
        currentCountryCode: detectedCulture.countryCode,
        detectedCulture: detectedCulture,
        name: null,
        surName: null,
        fromEmail:null,
        subscriptionNumber:null,
      }
    },

    props: {
      color: {
        type: String,
        default: '#9b9b9b'
      },
      rhombusSize: {
        type: Number,
        default: 10
      }
    },

    computed: {
      ...mapState('culture', ['countries', 'isDisplayTax']),

      ...mapState('account', {
        personalDetail: state => state.profile.personalDetail,
        shipping: state => state.profile.shipping,
        billing: state => state.profile.billing,
        hasBilling: state => state.profile.hasBilling
      }),

      ...mapGetters('account', ['isAuthenticated', 'hasAddress']),

      ...mapState('checkout', {
        cartDetails: state => state.cartDetails
      }),

      bundles () {
        return (this.$route.query.bundle && this.$route.query.bundle.split(',')) || null
      },

      isFamilyPack () {
        return this.bundles && this.bundles.length > 1
      },

      genericScript () {
        return this.isFamilyPack ? this.cartDetails.genericScript : this.cartDetails.groups[0].items[0].genericScript
      },

      genericHtml () {
        return this.isFamilyPack ? this.cartDetails.genericHtml : this.cartDetails.groups[0].items[0].genericHtml
      },

      pageTitle () {
        return this.isFamilyPack ? this.cartDetails.pageTitle : this.cartDetails.groups[0].items[0].pageTitle
      },

      coupon () {
        return this.$route.query.coupon || null
      },

      storedCartItems () {
        return JSON.parse(window.sessionStorage.getItem('storedCartItems')) || null
      },

      bundlesWithQuantity () {
        if (this.storedCartItems) {
          return this.storedCartItems
        } else {
          if (this.coupon) {
            return this.bundles && this.bundles.map(bundle => ({
              name: bundle,
              quantity: 1,
              promotionCodes: [this.coupon]
            }))
          } else {
            return this.bundles && this.bundles.map(bundle => ({
              name: bundle,
              quantity: 1,
              promotionCodes: []
            }))
          }
        }
      },

      bundlesWithNullPromotion () {
        return this.bundlesWithQuantity.map(item => ({
          name: item.name,
          quantity: item.quantity,
          promotions: []
        }))
      },

      bundlesWithNullPromotionCodes () {
        return this.bundlesWithQuantity.map(item => ({
          name: item.name,
          quantity: item.quantity,
          promotionCodes: []
        }))
      },

      bundlesWithPromotions () {
        return this.cartDetails.groups.map(group => {
          return group.items.map(item => ({
            name: item.name,
            quantity: item.quantity,
            promotions: item.promotions
          }))
        })
      },

      previewBundle () {
        return flatten(this.bundlesWithPromotions) || this.bundlesWithNullPromotion
      },

      isCheckoutStepRoute () {
        return this.$route.name === 'checkout'
      },

      vatDescription () {
        return this.cartDetails.summary.payNow.hasExtraTax ? this.$t('common.product.info.excludeVat', 'Prices exclulding VAT') : this.$t('common.product.info.includeVat', 'Prices inclulding VAT')
      },

      bundlesName () {
        return this.bundlesWithQuantity.map(bundle => bundle.name)
      }, 

      bundlesWithDetails () {
        let bundles = []
        this.cartDetails.groups.forEach(group => {
          group.items.forEach(item => {
            let price, frequency
            if (item.monthlyCharge != null) {
              price = item.monthlyCharge.original
              frequency = 1
            } else if (item.quarterlyCharge != null) {
              price = item.quarterlyCharge.original
              frequency = 3
            } else if (item.semiAnnualCharge != null) {
              price = item.semiAnnualCharge.original
              frequency = 6
            } else if (item.specificMonthsCharges && item.specificMonthsCharges.length > 0) {
              item.specificMonthsCharges.forEach(specificItem => {
                price = specificItem.charge.original
                frequency = specificItem.specificMonths
              })
            }
            bundles.push({
              name: item.name,
              quantity: item.quantity,
              ctn: item.philips12NC,
              price: price,
              frequency: frequency
            })
          })
        })
        return bundles
      },

      bundleflag (){ 
        if(this.cartDetails.groups[0].items[0].bundleAvailable === 'false'){
          return true 
        } 
      }
    },

    metaInfo () {
      return {
        title: this.pageTitle
      }
    },

    mounted(){
        /*-----cart Pageload event ---------*/
     
     this.trackGoogleAnalyticsSimple({ 
      trigger: 'ecommerce.checkout.cartview',
      event: 'ecommerceEvent',
      marketPlaceParticipant: 'Philips',
      ecommerce: {
          currencyCode:this.cartDetails.groups[0].items[0].currencyCode,
          cart: {
            products:[ 
              { 
                      //id: this.cartDetails.groups[0].items[0].philips12NC,
                      locale: this.detectedCulture.code,
                      quantity: this.bundlesWithQuantity[0].quantity, 
                      price:this.bundlesWithDetails[0].price,
                      originalPrice: this.cartDetails.summary.payNow.original, 
                      catCode: this.cartDetails.groups[0].items[0].philips12NC, 
                      bundleType: this.bundles[0], 
                      marketPlaceParticipant: 'Philips'
                    
              }
            ] 
            
          }
        }
    
      })   
   
    },

    methods: {
      ...mapMutations('account', [
        'setPersonalDetailItem',
        'setShippingAddressItem',
        'setBillingAddressItem'
      ]),


       openModalStep2 () {
        this.$bus.$emit('open-modal', 'newFlowForCancelReplenishment')
      },
      
       openModalStep3 () {
        Vue.api.subscription.sendcancelemail(this.name,this.surName,this.fromEmail,this.subscriptionNumber)
        this.$bus.$emit('open-modal', 'newFlowForCancelReplenishment1')
        this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment')
        
       },

       test () {
      this.$bus.$emit('close-modal', 'newFlowForCancelReplenishment1')
      window.location.reload()

       },

      backToCart () {
        window.sessionStorage.setItem('storedCartItems', JSON.stringify(this.bundlesWithQuantity))
        const canadaLanguage = window.localStorage.getItem('canadaLanguage')
        if (canadaLanguage) {
          this.$router.replace({
            name: 'cart',
            query: {
              modified: 'true',
              language: canadaLanguage
            }
          })
        } else {
          this.$router.replace({
            name: 'cart',
            query: {
              modified: 'true'
            }
          })
        }
      }
    },

    async created () {
      const currentBundles = this.$route.query.bundle
      const canadaLanguage = !!this.$route.query.language && this.$route.query.language
      if (canadaLanguage) {
        window.localStorage.setItem('canadaLanguage', canadaLanguage)
      }
      const bundeleStorage = window.localStorage.getItem('lastBundle')
      window.localStorage.setItem('disablePayment', String(this.cartDetails.disablePayment))
      if (currentBundles) {
        const uniqBundle = uniq(currentBundles.split(',')).join(',')
        window.localStorage.setItem('lastBundle', uniqBundle)
        let routeQuery
        if (canadaLanguage) {
          if (this.storedCartItems) {
            routeQuery = Object.assign({}, this.$route.query, { bundle: uniqBundle, modified: 'true', language: canadaLanguage })
          } else {
            routeQuery = Object.assign({}, omit(this.$route.query, ['modified', 'language']), { bundle: uniqBundle, language: canadaLanguage })
          }
          this.$router.replace({
            name: this.$route.name,
            query: routeQuery
          })
        } else {
          if (this.storedCartItems) {
            routeQuery = Object.assign({}, this.$route.query, { bundle: uniqBundle, modified: 'true' })
          } else {
            routeQuery = Object.assign({}, omit(this.$route.query, ['modified', 'language']), { bundle: uniqBundle })
          }
          this.$router.replace({
            name: this.$route.name,
            query: routeQuery
          })
        }
      } else {
        if (this.$route.query.bundle) {
          this.$router.replace({
            name: this.$route.name,
            query: {
              bundle: this.$route.query.bundle
            }
          })
        } else {
          this.$router.replace({
            name: this.$route.name,
            query: {
              bundle: bundeleStorage
            }
          })
        }
      }

      try {
        await
          this.$store.dispatch('checkout/getCartDetails', {
            bundles: this.bundlesWithQuantity,
            excludePrice: true
          })
        this.Loading = true
        this.$store.commit('checkout/setSubscriptionIsPreviewing', true)
        this.$store.dispatch('checkout/getCartDetails', {
          bundles: this.bundlesWithQuantity,
          excludePrice: false
        }).then((data) => {
          this.Loading = false
          this.$store.commit('checkout/setCartDetails', data)
          this.bundlesWithDetails.forEach(item => {
            this.trackAjax({
              events: 'event110',
              products: `;${item.ctn};${item.quantity};${item.price};;frequency=${item.frequency}`
            })
          })
          this.isLoading = false
          this.$store.commit('checkout/setSubscriptionIsPreviewing', false)
        }).catch(error => {
          if (error.data.code === 'error.message.applyPromotionIsDuplicated') {
            this.$store.dispatch('checkout/getCartDetails', {
              bundles: this.bundlesWithNullPromotionCodes,
              excludePrice: false
            }).then((data) => {
              this.Loading = false
              this.$store.commit('checkout/setCartDetails', data)

              this.bundlesWithDetails.forEach(item => {
                this.trackAjax({
                  events: 'event110',
                  products: `;${item.ctn};${item.quantity};${item.price};;frequency=${item.frequency}`
                })
              })
            })
            this.isLoading = false
          }
        })
      } catch (error) {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
        this.isLoading = false
      }

      try {
        if (this.isAuthenticated) {
          await this.$store.dispatch('account/fetchProfile')
          this.isLoading = false
          if (this.fromSubscriptionError) {
            setTimeout(() => {
              this.$scrollTo('[data-scroll="paymentMethod"]', {
                offset: -60
              })
            }, 10)
          }
          const bundlesInfor = JSON.parse(window.sessionStorage.getItem('bundlesInfor'))
          const currentBundleNames = join(this.bundlesName, ',')
          if (bundlesInfor) {
            if (this.cartDetails.termsTexts) {
              bundlesInfor.termsTexts = this.cartDetails.termsTexts
              window.sessionStorage.setItem('bundlesInfor', JSON.stringify(bundlesInfor))
            }
            this.$store.commit('checkout/setBundlesInfor', bundlesInfor)
            try {
              const { isValid } = await Vue.api.cart.validateMaxQuantity(bundlesInfor.bundles)
              if (!isValid) {
                this.$notify({
                  type: 'error',
                  title: this.$t('validation.error.message.isNotAllowToSubscribe', 'You already have the maximum amount of subscriptions')
                })
                this.$router.push({
                  name: 'my-account'
                })
              }
            } catch (error) {
              this.$notify({
                type: 'error',
                title: extractErrorMessage(error)
              })
              this.$router.replace({
                name: 'cart',
                query: {
                  bundle: currentBundleNames
                }
              })
            }
          } else {
            try {
              const { isValid } = await Vue.api.cart.validateMaxQuantity(this.bundlesWithQuantity)
              if (isValid) {
                let bundlesInfors = {
                  bundles: this.bundlesWithNullPromotion,
                  genericScript: this.genericScript,
                  genericHtml: this.genericHtml,
                  pageTitle: this.pageTitle,
                  phoneNumberRequired: this.cartDetails.phoneNumberRequired,
                  phoneNumberVisible: this.cartDetails.phoneNumberVisible,
                  termsTexts: this.cartDetails.termsTexts
                }
                window.sessionStorage.setItem('bundlesInfor', JSON.stringify(bundlesInfors))
                this.$store.commit('checkout/setBundlesInfor', bundlesInfors)
              }
              window.sessionStorage.setItem('checkoutPageTitle', this.pageTitle)
              window.sessionStorage.setItem('subscriptionInfo', JSON.stringify(this.bundlesWithDetails))
              if (!isValid) {
                this.$notify({
                  type: 'error',
                  title: this.$t('validation.error.message.isNotAllowToSubscribe', 'You already have the maximum amount of subscriptions')
                })
                this.$router.push({
                  name: 'my-account'
                })
              }
            } catch (error) {
              this.$notify({
                type: 'error',
                title: extractErrorMessage(error)
              })
              this.$router.replace({
                name: 'cart',
                query: {
                  bundle: currentBundleNames
                }
              })
            }
          }
          this.trackUserReady(this.personalDetail)
        } else {
          this.isLoading = false
        }
      } catch (error) {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      }
      this.$bus.$off('scroll-next-step').$bus.$on('scroll-next-step', (element, offset) => {
        setTimeout(() => {
          this.$scrollTo(element, {
            offset: offset || -60
          })
        }, 10)
      })
    }
  }
</script>

<style lang="scss">
  .CheckoutPage {
    margin-bottom: .87rem;

    .Form_control {
      border-width: 0 0 .01rem 0;
      border-color: rgba(216, 216, 216, .5);
    }

    .container-checkout {
      max-width: 8.28rem;

      .AppButton {
        width: 100%;
      }
    }

    .CheckoutPaymentMethod {
      border-bottom: .02rem solid $border-color;

      &.step-show {
        border-bottom: none;
      }

      .title-step {
        padding: .175rem .1rem;
      }
    }

    &_content {
      display: flex;
      margin: 0 auto;
      justify-content: space-around;
      flex-direction: column;
      padding: .15rem;

      .container-checkout {
        width: 100%;
        order: 2;

        @include media(tablet) {
          max-width: 8.28rem;
          order: 2;
        }

        @include media(desktop) {
          max-width: 8.28rem;
          order: 1;
        }
      }

      .cancel {
        display: flex;
        width: 100%;
        border: 1px solid #ccc;
        margin-top: 50px;
        padding: 20px;
        background-color: #e8e8e8;

        .demo1 {
          margin-left: auto;
        }

        .newFlowForCancelReplenishment_popUp {
          text-align: center;
        }

        .content {
          text-align: start;
        }
      }

      .CheckoutPage_cart {
        padding: 0;
        width: 100%;
        order: 1;

        @include media(desktop) {
          padding: .4rem 0;
          max-width: 4.14rem;
          order: 2;
          margin-left: .2rem;
        }

        @include media(tablet) {
          width: 100%;
          order: 1;
        }

        .CheckoutPage_cart-right {
          border: .01rem solid #e8e8e8;
          border-radius: .08rem;

          .ShoppingCartPayment {
            position: relative;
            padding: .16rem;
            border-bottom: .01rem solid #e8e8e8;

            &-now {
              // margin-bottom: .3rem;
              p {
                display: flex;
                justify-content: space-between;
              }

              &_item {
                font-size: .17rem;
                line-height: .25rem;
                margin-bottom: .14rem;
                color: #212121;

                p {
                  margin-bottom: .08rem;

                  &:last-of-type {
                    margin-bottom: 0;
                  }
                }

                .deliver {
                  .green {
                    color: #5f9920;
                    line-height: .25rem;
                    font-weight: bold;
                    font-size: .17rem;
                  }
                }
              }

              &_total {
                font-size: .2rem;
                line-height: .28rem;
                font-weight: 700;
                padding: .1rem 0;
                border-top: .01rem solid #696969;
              }
            }

            &-deferred {
              margin-top: .3rem;

              h4 {
                font-size: .16rem;
                line-height: .24rem;
                margin-bottom: .16rem;
              }

              &_item {
                margin-bottom: .14rem;

                &_header {
                  display: flex;
                  justify-content: space-between;
                  font-size: .16rem;
                  line-height: .24rem;

                  p {
                    .date {
                      font-size: .12rem;
                      line-height: .17rem;
                      color: #787878;
                    }

                    .discount {
                      font-weight: 700;
                      color: $orange;
                    }

                    .original {
                      font-weight: 700;

                      &.has-discount {
                        text-decoration: line-through;
                        font-weight: 400;
                        font-size: .12rem;
                        line-height: .17rem;
                        color: #9e9e9e;
                      }
                    }
                  }
                }

                .text-right {
                  .discount,
                  .original {
                    display: block;
                  }
                }

                &_body {
                  font-size: .12rem;
                  line-height: .17rem;
                  padding-left: .15rem;
                  margin-top: .16rem;
                  border-left: .01rem solid #e8e8e8;

                  > div {
                    margin-bottom: .12rem;

                    p {
                      display: flex;
                      justify-content: space-between;
                    }

                    &:last-of-type {
                      margin-bottom: 0;
                    }
                  }

                  .description {
                    display: inline-flex;
                    flex-direction: column;
                    width: 2.32rem;
                  }

                  .label {
                    color: #787878;
                    font-weight: 700;
                  }

                  .discount {
                    color: $orange;
                  }
                }
              }

              .btn-toggle {
                display: flex;
                align-items: center;
                font-size: .16rem;
                line-height: .24rem;
                color: $blue;
                font-weight: 500;
                cursor: pointer;

                .icon {
                  width: .12rem;
                  height: .12rem;
                  margin: 0 .06rem;
                  color: #212121;
                }

                &.expand {
                  .icon {
                    transform: rotate(180deg);
                  }
                }
              }

              .toggle-externals {
                margin-top: .4rem;
              }
            }

            .AppSpinner {
              position: relative;
              top: 50%;
              left: 50%;
            }
          }

          .CheckoutPage_cart-product {
            .Product {
              border-bottom: .01rem solid #e8e8e8;
              margin: .1rem;
              margin-right: .16rem;

              .img-holder {
                width: .72rem;
                height: .72rem;
                margin: .16rem .16rem .24rem;
              }

              &_name {
                font-size: .14rem;
                line-height: .22rem;
                color: #3c3c3c;

                @include media(desktop) {
                  min-width: 35%;
                }
              }

              &_price {
                &_item {
                  .origin,
                  .discount {
                    font-weight: bold;
                    font-size: .17rem;
                    line-height: .25rem;
                    white-space: -.001rem;
                    color: #323232;
                  }

                  .origin.has-discount {
                    text-decoration: line-through;
                    font-weight: 400;
                    font-size: .12rem;
                    color: #9e9e9e;
                  }
                }

                @include media(desktop) {
                  max-width: 48%;
                }
              }

              .hide-mobile {
                .Product_text {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }
              }

              .show-mobile {
                max-width: 70%;
              }
            }
          }

          .FpDiscountBox {
            padding: 0 .16rem;

            &_header {
              .discount-tips {
                color: #1474a4;
                font-weight: 500;
              }
            }

            .AppSpinner {
              right: 50%;
              margin: .2rem 0;
            }
          }
        }

        .backToCart {
          font-size: .16rem;
          line-height: .22rem;
          color: #1474a4;
          margin: .09rem 0 .18rem;
          cursor: pointer;
        }
      }

      @include media(desktop) {
        flex-direction: row;
      }
    }
  }
</style>
